import { Receipt, Expense, Income, CreditNote } from "../classes";
import Helper from "../plugins/Helper/Helper";
export class IncomeExpense {
  constructor(data) {
    this.date = data.date
    this.documentId = data.documentId || ""
    this.detail = data.detail || ""
    this.contractId = data.contractId || ""
    this.category = data.category || ""
    this.categoryItem = data.categoryItem || ""
    this.totalNonVatValue = data.totalNonVatValue || 0
    this.totalVatValue = data.totalVatValue || 0
    this.totalValue = data.totalValue || 0
    this.createdBy = data.createdBy
    this.type = data.type
    this.receipt = data.receipt
    this.expense = data.expense
    this.income = data.income
    this.creditNote = data.creditNote
    this.createdByText = this.createdBy ? `${this.createdBy.firstName} ${this.createdBy.lastName}` : '-'
  }

  static async getIncomeExpenseBetweenDateByMarket(fromData) {
    let { marketId, startDate, endDate } = fromData
    let incomeExpenseList = []

    let receipts = await Helper.queryMore(Receipt.getReceiptsBetweenDateByMarket, {...fromData})
    for (let receipt of receipts) {
      if (receipt.documentId && receipt.isPaid) {
        let businessName = ""
        if (receipt.contract) businessName = receipt.contract.businessName || ""
        if (receipt.booking) businessName = receipt.booking.businessName || ""
        let income = new IncomeExpense({
          date: receipt.date,
          documentId: receipt.documentId || "-",
          detail: `รับเงิน ${receipt.documentTypeString} จาก ${businessName}`,
          contractId: receipt.contract?.contractId || "-",
          category: receipt.documentTypeString,
          totalNonVatValue: receipt.totalNonVatValue,
          totalVatValue: receipt.totalVatValue,
          totalValue: receipt.totalValue,
          createdBy: receipt.createdBy,
          type: "receipt",
          receipt: receipt
        })
        incomeExpenseList.push(income)
      }
    }

    let expenses = await Expense.getExpenseBetweenDateByMarket(fromData)
    for (let expense of expenses) {
      let businessName = ""
      if (expense.contract) businessName = expense.contract.businessName || ""
      let _expense = new IncomeExpense({
        date: expense.date.iso,
        detail: expense.detail || "-",
        documentId: "-",
        contractId: expense.contract?.contractId || "-",
        category: expense.category.name || "-",
        categoryItem: expense.category,
        totalNonVatValue: expense.originalPrice * -1,
        totalVatValue: expense.totalVatValue * -1,
        totalValue: expense.totalValue * -1,
        createdBy: expense.createdBy,
        type: "expense",
        expense: expense
      })
      incomeExpenseList.push(_expense)
    }

    let incomes = await Income.getIncomeBetweenDateByMarket(fromData)
    for (let income of incomes) {
      let businessName = ""
      if (income.contract) businessName = income.contract.businessName || ""
      let _income = new IncomeExpense({
        date: income.date.iso,
        detail: income.detail || "-",
        documentId: "-",
        contractId: income.contract?.contractId || "-",
        category: income.category.name || "-",
        categoryItem: income.category,
        totalNonVatValue: income.originalPrice,
        totalVatValue: income.totalVatValue,
        totalValue: income.totalValue,
        createdBy: income.createdBy,
        type: "income",
        income: income
      })
      incomeExpenseList.push(_income)
    }

    let creditNotes = await CreditNote.getCreditNotesBetweenDateByMarket(fromData)
    for (let creditNote of creditNotes) {
      if (creditNote.documentId) {
        let expense = new IncomeExpense({
          date: creditNote.date,
          documentId: creditNote.documentId || "-",
          detail: `ลดหนี้ให้กับ ${creditNote.invoice?.documentId}`,
          contractId: creditNote.contract?.contractId || "-",
          category: "ใบลดหนี้",
          totalNonVatValue: creditNote.totalNonVatValue * -1,
          totalVatValue: creditNote.totalVatValue * -1,
          totalValue: creditNote.totalValue * -1,
          createdBy: creditNote.createdBy,
          type: "credit-note",
          creditNote: creditNote
        })
        incomeExpenseList.push(expense)
      }
    }
    return incomeExpenseList.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date)
    })
  }
}